
import React from "react";
import john from "../../assets/avatar3.png";
import "./aboutme.css";


function AbooutMe() {
    const highlights = [
        "Software Engineer with production DevOps and full-stack experience.",
        "Built CI/CD, cloud automation, and internal developer tools for large engineering teams.",
        "Comfortable across React, Next.js, Node.js, Python, Go, C#, Kubernetes, GCP, AWS, and Cloudflare."
    ];

    return (
        <section className="bg-white py-12 px-4 lg:px-10">
            <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-8 lg:grid-cols-[0.85fr_1.15fr]">
                <div className="flex justify-center">
                    <img
                        className="w-64 rounded-2xl shadow-2xl lg:w-80"
                        src={john}
                        alt="John E. Youte"
                    />
                </div>
                <div className="rounded-2xl bg-blue-change p-6 text-white shadow-2xl lg:p-10">
                    <p className="text-sm font-bold uppercase tracking-wide text-blue-second">About Me</p>
                    <h1 className="mt-2 text-3xl font-black lg:text-5xl">Software Engineer focused on reliable systems.</h1>
                    <p className="mt-5 text-base leading-relaxed lg:text-lg">
                        I build practical software across cloud infrastructure, developer tooling, and full-stack web products. My recent work includes CI/CD pipelines, GitOps workflows, DNS automation, RAG tooling, and production systems used by thousands of engineers and millions of users.
                    </p>
                    <div className="mt-6 grid gap-3">
                        {highlights.map((item) => (
                            <div key={item} className="rounded-xl bg-white p-3 text-left text-sm font-bold text-blue-change shadow-lg lg:text-base">
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AbooutMe;
